import { createUserManager } from 'redux-oidc';

const UserManagerConfig = {
    client_id: 'f7f320ba-eb0a-4216-9d3b-1b0fb228e02a', //ROSS PROD
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/userlogin`,
    response_type: 'token',
    scope: 'a74545ba-9908-48e4-8bd2-bfe5877958e7/user.impersonation.scope',
    authority: 'https://login.microsoftonline.com/0039204c-2313-4416-bdc3-42fcf01fdbd6/v2.0/.well-known/openid-configuration',
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silentrenew`,
    automaticSilentRenew: true,
    includeIdTokenInSilentRenew: false,
    filterProtocolClaims: true,
    loadUserInfo: false,
    revokeAccessTokenOnSignout: true,
    silentRequestTimeout: 100000,
    accessTokenExpiringNotificationTime: 300
};

const _UserManager = createUserManager(UserManagerConfig);

export default _UserManager;
